export const authTemplate = document.querySelector('.template-auth');
